import { BaseContainerModel } from '../../base-container.model';
import { bl_dgmkt_treatment_execution_hdr_RowClass } from '../../../dbschema';

export class DgMktTreatmentExecutionContainerModel extends BaseContainerModel {
  bl_dgmkt_treatment_execution_hdr: bl_dgmkt_treatment_execution_hdr_RowClass =
    new bl_dgmkt_treatment_execution_hdr_RowClass();
}
